// Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

export interface StatSummary {
    curr: number;
    avg: number;
    min: number;
    max: number;
}

export function fmtNumber(n: number): string {
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
    return n.toLocaleString();
}

export function fmtDate(iso: string): string {
    try {
        return new Date(iso + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch { return iso; }
}

export function extractVersion(updateLevel?: string, productName?: string): string {
    if (updateLevel && updateLevel !== '2147483647') {
        const m = updateLevel.match(/(\d+\.\d+\.\d+)/);
        if (m) return m[1];
    }
    // Fallback: extract from product name 
    if (productName) {
        const m = productName.match(/(\d+\.\d+\.\d+)/);
        if (m) return m[1];
    }
    return '';
}

/** Strip escaped quotes from jdkVersion strings  */
export function cleanJdkVersion(raw?: string): string {
    return (raw ?? '').replace(/"/g, '').trim();
}

export function computeStats(values: number[]): StatSummary {
    if (values.length === 0) return { curr: 0, avg: 0, min: 0, max: 0 };
    return {
        curr: values[values.length - 1],
        avg: Math.round(values.reduce((a, b) => a + b, 0) / values.length),
        min: Math.min(...values),
        max: Math.max(...values),
    };
}
